var links = {
  "withMagicUnderlines": "pb-utils__withMagicUnderlines",
  "withMagicUnderlinesInverted": "pb-utils__withMagicUnderlinesInverted",
  "withMagicUnderlinesChild": "pb-utils__withMagicUnderlinesChild"
};
export default links;